const channel = new BroadcastChannel("session_sync_channel");

export const initSessionSync = (callback) => {

  channel.onmessage = (event) => {

    if (event.data.type === "REQUEST_SESSION") {

      const sessionData = {};

      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        sessionData[key] = sessionStorage.getItem(key);
      }

      channel.postMessage({
        type: "SESSION_DATA",
        payload: sessionData,
      });
    }

    if (event.data.type === "SESSION_DATA") {

      const data = event.data.payload;

      if (sessionStorage.length === 0) {
        Object.keys(data).forEach((key) => {
          sessionStorage.setItem(key, data[key]);
        });
      }

      if (callback) callback();
    }

    if (event.data.type === "LOGOUT") {
      sessionStorage.clear();
      window.location.href = "/login";
    }

  };

};

export const requestSession = () => {
  channel.postMessage({
    type: "REQUEST_SESSION",
  });
};

export const broadcastLogout = () => {
  channel.postMessage({
    type: "LOGOUT",
  });
};